"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertDatePickerParamsToStrings = void 0;
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _localization = require("@lt/localization");
var _date = require("../../utils/date");
var _pluralizeUtils = require("../../utils/pluralizeUtils");
var convertDatePickerParamsToStrings = exports.convertDatePickerParamsToStrings = function convertDatePickerParamsToStrings(_ref) {
  var leftValue = _ref.leftValue,
    rightValue = _ref.rightValue,
    startDatePreset = _ref.startDatePreset,
    shift = _ref.shift,
    nights = _ref.nights,
    nightsPreset = _ref.nightsPreset;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var isPreset = !!(startDatePreset || nights || nightsPreset);
  var leftDateString = convertDatesToStringWithEllipsis(leftValue, shift);
  var rightDateString = convertDatesToStringWithEllipsis(rightValue, shift);
  var startDateOrPreset = leftDateString || (startDatePreset === null || startDatePreset === void 0 ? void 0 : startDatePreset.title) || '';
  var nightsString = nights ? "".concat(t('cigarettePreview.datePicker.nightsPreposition'), " ").concat(convertNightsIntervalToString(nights)) : '';
  var endDateOrDuration = rightDateString || (nightsPreset === null || nightsPreset === void 0 ? void 0 : nightsPreset.title) || nightsString;
  return {
    isPreset: isPreset,
    left: startDateOrPreset,
    right: endDateOrDuration
  };
};
var convertDatesToStringWithEllipsis = function convertDatesToStringWithEllipsis(dateCell, shift) {
  var isShort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!(dateCell !== null && dateCell !== void 0 && dateCell.date)) return '';
  var date = dateCell.date;
  if (shift === 0) {
    var formatToken = isShort ? 'd MMM' : 'd MMMM';
    return (0, _date.formatDate)(date, formatToken);
  }
  var separator = isShort ? '...' : ' ... ';
  return "".concat((0, _date.formatDate)((0, _addDays["default"])(date, -shift), 'd MMM')).concat(separator).concat((0, _date.formatDate)((0, _addDays["default"])(date, shift), 'd MMM'));
};
var convertNightsIntervalToString = function convertNightsIntervalToString(nightsInterval) {
  var from = nightsInterval.from,
    to = nightsInterval.to;
  var nightsString = "".concat(from === to ? '' : "".concat(from, "...")).concat(to, " ").concat((0, _pluralizeUtils.pluralizeNights)(to));
  return nightsString;
};